import { getToken } from '../utils/LoginManager';

export const isAutenticated = () => {
    const token = getToken();
    //console.log(token);
    
    return  token;
};